import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_raqzmc7tej: FaireBrandEntity = {
  token: "b_raqzmc7tej",
  type: "brand",
  name: "AmazeU",
  avatarUrl:
    "https://cdn.faire.com/fastly/1579791095b9deff881922a466481451f7eddfd5368a437cc04083ae23fbf058.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a144a4e8bf5e9dfcc2c038f5a16cc987565173fd1e6aaa6f8e542a39d041f9f3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/1579791095b9deff881922a466481451f7eddfd5368a437cc04083ae23fbf058.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a144a4e8bf5e9dfcc2c038f5a16cc987565173fd1e6aaa6f8e542a39d041f9f3.png",
  location: "Toronto, ON, CAN",
  minimumOrderDollars: 209,
  rating: 5,
  reviewCount: 4,
  isInsider: false,
  description:
    "“ALL SHIPMENTS TO USA WILL BE TARIFF PRE-PAID AND THERE WILL NOT BE ANY TARIFF/DUTY CHARGED TO USA CUSTOMERS”.\n\nWe are a premier online destination for exquisite and high-quality Gemstone products, home decor, for all things related to creating a beautiful and stylish home.\nWe work with artisans and crafters dedicated to bringing you unique and one-of-a-kind handmade products. With a focus on creativity, craftsmanship, and sustainability, we curate a diverse collection of handmade items that are sure to add a touch of artistry and individuality to your life.\n\nWith a passion for beauty and craftsmanship, we curate a stunning collections that caters to all tastes and occasions",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.295Z",
    importedBy: "entity-db-cli",
  },
};
